import { useQuery } from '@tanstack/react-query';
import { activityApi } from '../api/client';

interface ActivityQueryParams {
  userId?: string;
  deviceId?: string;
  startDate?: string;
  endDate?: string;
  granularity?: 'hour' | 'day' | 'week';
}

export function useActivitySummary(
  params: Omit<ActivityQueryParams, 'granularity'> = {},
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ['activitySummary', params],
    queryFn: async () => {
      const response = await activityApi.getSummary(params);
      return response.data;
    },
    enabled: options.enabled,
  });
}

export function useActivityTimeline(
  params: ActivityQueryParams = {},
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ['activityTimeline', params],
    queryFn: async () => {
      const response = await activityApi.getTimeline(params);
      return response.data;
    },
    enabled: options.enabled,
  });
}
